import { render, staticRenderFns } from "./chAr.vue?vue&type=template&id=84f215d4"
import script from "./chAr.vue?vue&type=script&lang=js"
export * from "./chAr.vue?vue&type=script&lang=js"
import style0 from "./chAr.vue?vue&type=style&index=0&id=84f215d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports